import {combineReducers} from 'redux';
import asyncActionsCountReducer from './asyncActionsCountReducer';
import errorReducer from './errorReducer';
import eventsReducer from './eventsReducer';
import googlePlacesReducer from './googlePlacesReducer';
import planningFormReducer from './planningFormReducer';
import recommendationsReducer from './recommendationsReducer';
import youtubeVideosReducer from './youtubeVideosReducer';
import userReducer from './userReducer';
import viewReducer from './viewReducer';
import templatesReducer from './templatesReducer';
import { routerReducer } from 'react-router-redux';

const allReducers = combineReducers({
    user:               userReducer,
    events:             eventsReducer,
    errorMessage:       errorReducer,
    placesSuggestions:  googlePlacesReducer,
    recommendations:    recommendationsReducer,
    videos:             youtubeVideosReducer,
    view:               viewReducer,
    templates:          templatesReducer,
    planningForm:       planningFormReducer,
    asyncActionsCount:  asyncActionsCountReducer,
    router:             routerReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        state = undefined
    }

    return allReducers(state, action)
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js